export default __webpack_public_path__ + "static/media/Opera.8d3706c1.mp3";